module.exports = __webpack_public_path__ + "agregation.f200392241dd7e28ebb8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/agregation.svg
// module id = ./src/assets/img/agregation.svg
// module chunks = main